<template>
  <div class="sc-thanks-container">
    <h1 class="page-title"><b>{{ $t('thank_you.thank_you_header') }}</b></h1>
    <sc-progress-steps :steps="steps" class="sc-thanks-progress-steps"/>
    <div class="sc-thanks-id-and-links">
      <div class="sc-thanks-order-id-container-card-payment">
        <div class="sc-thanks-order-label-and-id">
          <span class="sc-thanks-order-label">
            {{ $t('thank_you.order_id') }}
          </span>
          <span class="sc-thanks-order-id">
            {{ orderId }}
          </span>
        </div>
        <div class="sc-thanks-download-contract-label">{{ $t('thank_you.download_contract_label') }}</div>
        <div class="transaction-info">
          <div class="sc-thanks-order-label-and-id">
            <span class="sc-thanks-order-label">
              {{ $t('payment.simplepay_transaction_id', { id: transactionId }) }}
            </span>
          </div>
          <div class="sc-thanks-order-label-and-id">
            <span class="sc-thanks-order-label">
              {{ $t('payment.transaction_time', { time: startTimeFormatted }) }}
            </span>
          </div>
        </div>
        <!-- <div class="sc-thanks-links">
          <sc-download-link href="#" :text="$t('thank_you.download_bill')"/>
        </div> -->
        <div class="sc-thanks-links">
          <sc-download-link v-if="contractUrl" :href="contractUrl" :text="$t('thank_you.download_contract')" />
        </div>
      </div>
      <div class="to-home">
        <router-link :to="Routes.home()" class="no-text-decoration">
          <rounded-button color="outline" size="large">
              {{ $t('thank_you.main_page') }}
          </rounded-button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { ScProgressSteps, ScDownloadLink } from 'smartcommerce-component-library'
import thanksMixin from '../mixins/thanks.mixin'
import { Routes } from '../utils/Routes'
import RoundedButton from '../../shared/components/RoundedButton'

export default {
  name: 'ThanksBankCard',
  components: {
    ScProgressSteps, ScDownloadLink, RoundedButton
  },

  mixins: [thanksMixin],

  created () {
    if (!this.checkLastOrderResponse()) {
      this.$router.push(Routes.PAYMENT)
      return
    }

    const PostOrderStepLabels = [
      'thank_you.step_price_arrived',
      'thank_you.step_register_vehicles',
      'thank_you.step_appointment_book',
      'thank_you.step_install_device'
    ]
    for (let i = 0; i < PostOrderStepLabels.length; i++) {
      let object = { text: this.$t(PostOrderStepLabels[i]), checked: false }
      object.checked = i === 0
      this.steps.push(object)
    }

    this.$ga && this.$ga.event({
      eventCategory: 'Order or Purchase',
      eventAction: 'Successful',
      eventLabel: 'Bankcard',
      eventValue: this.total
    })
  },
  data () {
    return {
      steps: [],
      Routes,
      transactionId: null
    }
  },

  computed: {
    startTime () {
      return this.lastCheckBankCardPaymentResponse ? this.lastCheckBankCardPaymentResponse.startTime : null
    },

    startTimeFormatted () {
      return this.$options.filters.date(this.startTime, 'YYYY.MM.DD. hh:mm:ss')
    }
  }
}
</script>

<style scoped lang="scss">
.transaction-info {
  margin-top: 15px;
  font-size: 14px;
}

.sc-thanks-container {
  margin: auto;
  width: 80%;
}
.sc-thanks-progress-steps {
  padding: 0px;
  height: 120px;
}
.sc-thanks-order-id-container-card-payment {
  width: 100%;
  margin-bottom: 50px;
  margin-top: 60px;
  float: left;
}
.sc-thanks-order-label {
  color: $sc-text-dark;
  margin-right: 5px;
}
.sc-thanks-order-id {
  font-size: 18px;
  font-weight: 600;
  color: $sc-text-dark;
}
.sc-thanks-download-contract-label {
  width: 100%;
  text-align: left;
}
.sc-thanks-order-label-and-id {
  text-align: left;
}
.sc-thanks-links {
  text-align: left;
  margin: 20px 0px;
  font-size: 16px;
  font-weight: 600;
}
.sc-thanks-id-and-links {
  display: flow-root;
}
.to-home {
  width: 200px;
  margin: 30px auto;
}

@media(max-width: 768px) {
  .page-title{
    margin: 15px 0px;
  }

  .sc-thanks-progress-steps{
    display: none;
  }

  .to-home{
    width: 100%;

    button{
      width: 80%;
      min-width: inherit;
      margin: auto;
    }
  }
}
</style>
